import React from "react"

function PPMatchingSkeletonCard({ variant = "candidate" }) {
    const isMaster = variant === "master"

    return (
        <div
            className={
                "pp-matching-skeleton-card" + (isMaster ? " pp-matching-skeleton-card--master" : "")
            }
            aria-hidden="true"
        >
            <div className="pp-matching-card-row">
                <div
                    className={
                        "pp-matching-skeleton__image " +
                        (isMaster ? "pp-matching-product-img--master" : "pp-matching-product-img--candidate")
                    }
                />
                <div className="pp-matching-card-row__content">
                    {!isMaster && <div className="pp-matching-skeleton__line pp-matching-skeleton__line--badge" />}
                    <div className="pp-matching-skeleton__line pp-matching-skeleton__line--title" />
                    <div className="pp-matching-skeleton__line pp-matching-skeleton__line--meta" />
                    <div className="pp-matching-skeleton__line pp-matching-skeleton__line--meta pp-matching-skeleton__line--short" />
                    <div className="pp-matching-skeleton__line pp-matching-skeleton__line--price" />
                    <div className="pp-matching-skeleton__actions">
                        <div className="pp-matching-skeleton__line pp-matching-skeleton__line--link" />
                        <div className="pp-matching-skeleton__line pp-matching-skeleton__line--button" />
                    </div>
                </div>
                {isMaster ? (
                    <div className="pp-matching-skeleton__line pp-matching-skeleton__line--reject" />
                ) : (
                    <div className="pp-matching-skeleton__score" />
                )}
            </div>
        </div>
    )
}

export default function PPMatchingWorkspaceSkeleton({ candidateCount = 3 }) {
    return (
        <div className="pp-matching-workspace-skeleton" aria-busy="true" aria-live="polite">
            <PPMatchingSkeletonCard variant="master" />
            <div className="pp-matching-candidate-list pp-matching-candidate-list--skeleton">
                {Array.from({ length: candidateCount }, (_, index) => (
                    <PPMatchingSkeletonCard key={index} />
                ))}
            </div>
        </div>
    )
}
